'use client';

import { useSystemLabels } from '@eliadmin/core/src/hooks/use-system-labels';
import Link from '@eliadmin/core/src/components/link';

import { Button } from '@eliadmin/core/src/components/ui/button';

import { ROUTES } from '@eliadmin/core/src/constants/routes';
import { useCartQueryOpts } from '@eliadmin/core/src/hooks/cart/use-cart';
import { useQuery } from '@tanstack/react-query';
import { ButtonIcon } from '../ui/button-icon';

export function HeaderCartButton() {
  const systemLabels = useSystemLabels();
  const { data: cart, isLoading } = useQuery({ ...useCartQueryOpts() });

  return (
    <Button
      asChild
      variant={'none'}
      size={'none'}
      className="min-h-6 min-w-[7.5rem] whitespace-nowrap tabular-nums"
    >
      <Link
        aria-label={`Košík (${cart?.items?.length ?? 0}) — ${systemLabels('cart')}`}
        prefetch={false}
        href={ROUTES.CART()}
        aria-busy={isLoading}
      >
        <ButtonIcon
          url="/images/icons/shopping-bag-black.svg"
          alt="Košík"
          className="max-h-6 min-h-6 min-w-6 max-w-6"
        />
        Košík ({cart?.items?.length ?? 0})
      </Link>
    </Button>
  );
}
